import React, { useRef } from 'react'
import {
  BankModalContainer,
  BankWrapper,
  BankModalBackground,
  ClosedModalButton,
} from './style'
import { PlanName } from '../PlanName'

const PlanNameModal = ({ showModal, setShowModal }: any) => {
  const componentRef = useRef<HTMLDivElement>(null)

  const closeModal = (e: any) => {
    if (componentRef.current !== e.target) {
      setShowModal(false)
    }
  }

  return (
    <BankModalContainer>
      {showModal ? (
        <BankModalBackground>
          <BankWrapper>
            <ClosedModalButton onClick={closeModal} />
            <PlanName />
          </BankWrapper>
        </BankModalBackground>
      ) : null}
    </BankModalContainer>
  )
}

export { PlanNameModal }
